/* eslint-disable */
export const menuConstants = {
    OFFICE_LIST_MENU: "T0011",
    OFFICE_REGISTRATION_MENU: "T0010",
    CARE_MANAGER_LIST_MENU: "T0051",
    CARE_MANAGER_REGISTRATION_MENU: "T0050",
    SALES_HISTORY_LIST_MENU: "T0014",
    SALES_HISTORY_REGISTRATION_MENU: "T0013",
    TRIAL_USER_LIST_MENU: "T0021",
    TRIAL_USER_REGISTRATION_MENU: "T0020",
    CORPORATE_FACILITY_REGISTRATION_MENU: "T0015",
    CORPORATE_FACILITY_LIST_MENU: "T0016",

    QUESTIONARRIES_LIST_MENU: "T0042",
    QUESTIONARRIES_REGISTRATION_MENU: "T0042",

    MEDICAL_INSTITUTE_LIST_MENU: "M0041",
    MEDICAL_INSTITUTE_REGISTRATION_MENU: "M0040",
    DOCTOR_LIST_MENU: "M0051",
    DOCTOR_REGISTRATION_MENU: "M0050",
    MAIN_FRANCHISE_LIST_MENU: "M0081",
    MAIN_FRANCHISE_REGISTRATION_MENU: "M0080",
    SUB_FRANCHISE_LIST_MENU: "M0071",
    SUB_FRANCHISE_REGISTRATION_MENU: "M0070",
    PRACTITIONER_LIST_MENU: "M0061",
    PRACTITIONER_REGISTRATION_MENU: "M0060",
    USER_LIST_MENU: "M0002",
    USER_REGISTRATION_MENU: "M0001",
    SCREEN_LIST_MENU: "M2021",
    SCREEN_REGISTRATION_MENU: "M2020",
    ACCESS_AUTHORITY_LIST_MENU: "M2010",
    ACCESS_AUTHORITY_REGISTRATION_MENU: "M2011",
    GENERAL_PURPOSE_LIST_MENU: "M1010",
    GENERAL_PURPOSE_REGISTRATION_MENU: "M1010",
    HOJIN_MASTER_LIST_MENU: "M0091",
    HOJIN_MASTER_REGISTRATION_MENU: "M0090",
    HLP_TOOLS_DATA_VIEWER_MENU: "A0010",

};
